module.exports = __webpack_public_path__ + "img/phone-landscape.14b10846.svg";